import React from 'react';
import { ChecklistGroup, ChecklistItem } from '../types/checklist';
import { Group } from './Group';

interface GroupListProps {
  checklists: ChecklistGroup[];
  isGroupCompleted: (group: ChecklistGroup) => boolean;
  getGroupProgress: (group: ChecklistGroup) => number;
  onToggleGroup: (groupIndex: number) => void;
  onCheck: (groupIndex: number, itemIndex: number) => void;
  onInfo: (item: ChecklistItem, e: React.MouseEvent) => void;
}

export function GroupList({ checklists, isGroupCompleted, getGroupProgress, onToggleGroup, onCheck, onInfo }: GroupListProps) {
  return (
    <>
      {checklists.map((group, groupIndex) => (
        <Group
          key={group.title}
          group={group}
          index={groupIndex}
          isGroupCompleted={isGroupCompleted}
          getGroupProgress={getGroupProgress}
          onToggle={onToggleGroup}
          onCheckItem={onCheck}
          onInfo={onInfo}
        />)
      )}
    </>
  );
}